import { Button, styled, SxProps, Theme } from "@mui/material";
import React, { FC, ReactNode } from "react";

const CustomButton: FC<Props> = ({
  children,
  fullWidth,
  onClick,
  disabled = false,
  sx,
}) => {
  return (
    <StyledButton
      className={fullWidth && "fullWidth"}
      variant="contained"
      color="primary"
      fullWidth={fullWidth}
      onClick={onClick}
      disabled={disabled}
      sx={sx}
    >
      {children}
    </StyledButton>
  );
};

const StyledButton = styled(Button)(({ theme }) => ({
  maxWidth: 300,
  fontWeight: 700,
  borderRadius: "5px",
  boxShadow: "1px 1px 5px 0 rgba(0,0,0,.1)",
  fontFamily: '"Open Sans", Helvetica, Arial, Verdana, sans-serif',
  fontSize: "1rem",
  justifyContent: "space-evenly",
  "&:hover": {
    backgroundColor: theme.palette.primary.dark,
    color: theme.palette.primary.light,
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "0.8rem",
  },
  "&.fullWidth": {
    padding: ".6rem",
    marginTop: "1rem",
  },
}));

interface Props {
  children: ReactNode;
  fullWidth?: boolean;
  onClick?: () => void;
  disabled?: boolean;
  sx?: SxProps<Theme>;
}

export default CustomButton;
